import React, { useRef } from "react";
import styled from "styled-components";
import Button from "@mui/material/Button";
import { downloadImage } from "src/common";

const Modal = styled.div`
  top: 0;
  left: 0;
  background-color: rgba(0, 0, 0, 0.5);
  position: fixed;
  width: 100%;
  height: 100%;
  z-index: 1200;
  animation: show 0.5s;
  @keyframes show {
    0% {
      opacity: 0;
    }
    100% {
      opacity: 1;
    }
  }
`;

const WrapperImage = styled.div`
  width: 300px;
  height: 300px;
`;

const ImgFull = styled.img`
  width: 100%;
  height: 100%;
  object-fit: contain;
  // object-position: center;
  border-radius: 16px;
  box-shadow: rgb(0 0 0 / 16%) 1px 1px 5px 1px;
`;
const WrapperModal = styled.div`
  max-width: 880px;
  background-color: #ffffff;
  border-radius: 24px;
  box-shadow: 0px 11px 15px -7px rgba(0, 0, 0, 0.2),
    0px 24px 38px 3px rgba(0, 0, 0, 0.14), 0px 9px 46px 8px rgba(0, 0, 0, 0.12);
  width: fit-content;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  position: absolute;
  padding: 30px 25px;
  min-width: 444px;
  animation: showModal 0.5s;
  @keyframes showModal {
    0% {
      transform: translate(-50%, -60%);
    }
    100% {
      transform: translate(-50%, -50%);
    }
  }
`;

const WrapperModalInside = styled.div`
  width: auto;
  height: auto;
  // overflow-y: scroll;
  // overflow-x: hidden;
  margin-top: 100px;
  margin-bottom: 40px;
  margin-left: 150px;
  margin-right: 150px;
  ::-webkit-scrollbar {
    width: 7px;
    height: 7px;
  }

  /* Track */
  ::-webkit-scrollbar-track {
    background: transparent;
  }

  /* Handle */
  ::-webkit-scrollbar-thumb {
    background: #b9b9b9;
    border-radius: 100px;
  }

  /* Handle on hover */
  ::-webkit-scrollbar-thumb:hover {
    background: #b9b9b9;
  }
  ::-webkit-scrollbar-corner {
    background: transparent;
  }
  &:focus {
    outline: none;
  }

  .Button-New-Brand {
    color: #ffffff;
    width: 98%;
    margin: 8px;
    display: flex;
    justify-content: center;
    background: #e04132;
    box-shadow: 0px 3px 1px -2px rgba(0, 0, 0, 0.2),
      0px 2px 2px rgba(0, 0, 0, 0.14), 0px 1px 5px rgba(0, 0, 0, 0.12);
    border-radius: 16px;
    height: 52px;
    padding: 0 16px;
  }
  .Button-New-Brand:focus {
    background-color: #e04132;
  }
  .Button-New-Brand:hover {
    background-color: #e04132;
    opacity: 0.9;
  }
`;

function ModalFullImage({ close, title, image }) {
  const imageRef = useRef();
  const closeModal = () => {
    // setIsVisible(false)
    close();
  };

  return (
    <Modal>
      <WrapperModal>
        <WrapperModalInside>
          <WrapperImage>
            <ImgFull ref={imageRef} src={image} />
          </WrapperImage>
        </WrapperModalInside>
        <Button
          onClick={() => {
            // window.open(`${image}`, "_blank");
            downloadImage(`${image}`, "png");
          }}
          className="Button-New-Brand"
          style={{
            background: "#e04132",
            color: "#fff",
            borderRadius: "16px",
            marginLeft: "auto",
            marginRight: "auto",
            marginBottom: "32px",
            display: "flex",
            width: "50%",
            height: "42px",
          }}
        >
          Download Full Image
        </Button>
        <Button
          onClick={() => closeModal(false)}
          className="Button-New-Brand"
          style={{
            background: "#e04132",
            color: "#fff",
            borderRadius: "16px",
            margin: "auto",
            display: "flex",
            width: "64px",
            height: "42px",
          }}
        >
          ปิด
        </Button>
      </WrapperModal>
    </Modal>
  );
}

export default ModalFullImage;
